import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import usePageMeta from '../hooks/usePageMeta';

export default function ImpressumPage() {
  const { language, t } = useLanguage();
  usePageMeta('Impressum | Lino', 'Impressum und Anbieterkennzeichnung gemäß § 5 TMG.');

  return (
    <div style={{ minHeight: '100vh', paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Back Button */}
          <Link 
            to="/" 
            className="icon-button" 
            style={{ 
              display: 'inline-flex', 
              marginBottom: '32px',
              gap: '8px',
              alignItems: 'center'
            }}
          >
            <ArrowLeft size={20} />
            <span style={{ fontWeight: 500 }}>{t('nav.back')}</span>
          </Link>

          {/* Content */}
          <div style={{ maxWidth: '800px' }}>
            {language === 'de' ? (
              <>
                <h1 style={{ fontSize: '48px', fontWeight: 800, marginBottom: '32px' }}>
                  Impressum
                </h1>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Angaben gemäß § 5 TMG
                  </h2>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    Lino Harder<br />
                    Sankt-Jürgen-Straße 30<br />
                    18299 Laage<br />
                    Deutschland
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Kontakt
                  </h2>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    E-Mail: harderlino19@gmail.com<br />
                    Telefon: +49 1525 3804428
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Haftungsausschluss
                  </h2>
                  
                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Haftung für Inhalte
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                    Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                    nach den allgemeinen Gesetzen verantwortlich.
                  </p>

                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Haftung für Links
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
                    Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. 
                    Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der 
                    Seiten verantwortlich.
                  </p>

                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Urheberrecht
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
                    dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art 
                    der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
                    Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </section>
              </>
            ) : (
              <>
                <h1 style={{ fontSize: '48px', fontWeight: 800, marginBottom: '32px' }}>
                  Legal Notice
                </h1>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Information according to § 5 TMG
                  </h2>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    Lino Harder<br />
                    Sankt-Jürgen-Straße 30<br />
                    18299 Laage<br />
                    Germany
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Contact
                  </h2>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    Email: harderlino19@gmail.com<br />
                    Phone: +49 1525 3804428
                  </p>
                </section>

                <section style={{ marginBottom: '40px' }}>
                  <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
                    Disclaimer
                  </h2>
                  
                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Liability for Content
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                    The contents of our pages have been created with the utmost care. However, we cannot 
                    guarantee the accuracy, completeness and timeliness of the content. As a service provider, 
                    we are responsible for our own content on these pages in accordance with general laws.
                  </p>

                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Liability for Links
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8, marginBottom: '16px' }}>
                    Our offer contains links to external third-party websites, the content of which we have no 
                    influence on. Therefore, we cannot accept any liability for this external content. The 
                    respective provider or operator of the pages is always responsible for the content of the 
                    linked pages.
                  </p>

                  <h3 style={{ fontSize: '18px', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
                    Copyright
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: 1.8 }}>
                    The content and works created by the site operators on these pages are subject to German 
                    copyright law. Duplication, processing, distribution and any kind of exploitation outside 
                    the limits of copyright law require the written consent of the respective author or creator.
                  </p>
                </section>
              </>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
